<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Rack Bolt';
                }
            },
            component_id: {
                default(){
                    return 'hardware_joining_bolt';
                }
            },
            slab: {
                required: true
            },
            doorRange: {
                required: true
            },
            hardwareColour: {
                default(){
                    return '';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.doorRange, this.hardwareColour);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-joining-bolt?slab=' + this.slab + '&door_range=' + this.doorRange + '&hardware_colour=' + this.hardwareColour;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.doorRange + '_' + this.hardwareColour;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
